
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { postHeaders } from "@/api/api-require";
import axios from "axios";
import { State } from "vuex-class";
import i18n from "@/config/i18n";
@Component
export default class PiExport extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private data!: objAny;

  @Prop({ default: "" }) private fileName!: string;
  @Prop({ default: "post" }) private method!: string;
  @Prop({ default: ".xls" }) private command!: string;
  @Prop({ default: "" }) private url!: string;
  @Prop({ default: "size" }) private numberName!: string;
  @Prop({ default: true }) private isShowSize!: string;
  @State("sys") sys!: objAny;
  private size: number | string = "";
  private loading = false;
  async exportData() {
    let number = 10000;
    if (this.isShowSize) {
      if (this.size) {
        number = Number(this.size);
      }
      if (number <= 0) {
        this.$Message.warning({
          content: i18n.t("formText.exportPl") + ""
        });
        return;
      }
    }

    if (!this.loading) {
      const command = this.command;
      const json: objAny = {};
      if (this.isShowSize) {
        json[this.numberName] = number;
      }
      const data = Object.assign(this.data, json);
      const loginData = this.sys.userInfo;
      if (loginData.oprPkId) {
        data.oprPkId = loginData.oprPkId;
      }

      if (loginData.merchantPkId) {
        data.merchantPkId = loginData.merchantPkId;
      }
      if (data.endTime) {
        const thisTime = this["$common"].thisTimes("yyyy-MM-dd HH:MM:SS");
        const thisTimeArr = thisTime.split(" ");
        const endTimeArr = data.endTime.split(" ");
        if (
          thisTimeArr[0] === endTimeArr[0] &&
          endTimeArr[1] &&
          endTimeArr[1] === "23:59:59"
        ) {
          // 如果结束时间为当前一天
          data.endTime = thisTime;
        }
      }
      // data.Suffix = command;

      this.command = command;
      this.loading = true;
      const headers = postHeaders({ filename: "utf-8" });
      let url = this.$config.ajaxHost + this.url;
      if (this.method === "postStr" || this.method === "get") {
        url = url + "?" + this["$common"].parseParam(data);
      }
      axios({
        method: this.method === "get" ? "get" : "post",
        url: url,
        data: this.method === "postStr" ? {} : data,
        responseType: "arraybuffer",
        headers: headers
      })
        .then(async result => {
          this.loading = false;

          this.ab2str(result.data, (str: string) => {
            if (this.isJSON(str)) {
              const jsonData = JSON.parse(str);
              this.$Message.error(jsonData.msg);
            } else {
              this.loadBlob(result.data);
            }
          });
        })
        .catch(() => {
          this.loading = false;
          this.$Modal.error({
            title: i18n.t("tips") + "",
            content: i18n.t("formText.exportError") + ""
          });
        });
    }
  }
  public ab2str(u: Blob, f: Function) {
    const b = new Blob([u]);
    const r = new FileReader();
    const loadBlob = this.loadBlob;
    r.readAsText(b, "utf-8");
    r.onload = function() {
      if (f) {
        f.call(null, r.result); // eslint-disable-line
      }
    };
    r.onerror = function() {
      loadBlob(u);
    };
  }
  public isJSON(str: string) {
    if (typeof str === "string") {
      try {
        const obj = JSON.parse(str);
        if (typeof obj === "object" && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }
  public loadBlob(data: Blob) {
    const blob = new Blob([data], {
      type: "application/octet-stream;charset=utf-8"
    });
    const win: objAny = window;
    const doc: objAny = document;
    const downloadElement: objAny = doc.createElement("a");
    const href: objAny = win.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;
    const time =
      this.fileName !== ""
        ? this.fileName + "-" + this["$common"].thisTimes()
        : this["$common"].thisTimes();

    downloadElement.download = time + this.command; // 下载后文件名
    doc.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    doc.body.removeChild(downloadElement); // 下载完成移除元素
    win.URL.revokeObjectURL(href); // 释放blob对象
  }
}
